import { Typography } from 'antd';
import React from 'react';

export default function Home() {
    return <Typography>This is the home page</Typography>;
}
